import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import UserService from "services/UserService";
import TextInput from "components/Input/TextInput.js";
import CustomSelect from "components/Input/CustomSelect.js";
import AutocompleteInputMeters from "components/Input/AutocompleteInputMeters";
import AutocompleteTagsInput from "components/Input/AutocompleteTagsInput";
import FloatInput from "components/Input/FloatInput";
import MeteringPlanTree from "./MeteringPlanTree";
import DateInput from "components/Input/DateInput.js";
import Button from "@mui/material/Button";
import { makeStyles, withStyles } from "@mui/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import ImageList from "@mui/material/ImageList";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import styled from "styled-components";
import { metringPlanItemText } from "variables/MBM/geb";
import { aggchildrenData, valuetypeData, locationtypeData, planitemiconData } from "variables/MBM/lists/geb";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { postGEBMeteringPlanItem, putGEBMeteringPlanItem } from "services/ConfigServices";
import { NotificationManager } from "react-notifications";
import CustomSelectWithIcon from "components/Input/CustomSelectWithIcon";

const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const StyledTabs = withStyles({
  indicator: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "transparent",
    "& > span": {
      maxWidth: 80,
      width: "100%",
      backgroundColor: "#91C73C",
    },
  },
})((props) => <Tabs {...props} TabIndicatorProps={{ children: <span /> }} />);

const StyledTab = withStyles((theme) => ({
  root: {
    textTransform: "none",
    color: "#000",
    fontWeight: 400,
    fontFamily: '"Source Sans Pro",sans-serif',
    fontSize: '0.9375rem',
    marginRight: '8px',
    minWidth: "auto",
    display: "flex",
    fullWidth: true,
    "&:focus": {
      opacity: 1,
    },
  },
}))((props) => <Tab disableRipple {...props} />);

const UseSweetAlertStyle = makeStyles(sweetAlertStyle);
const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: '16px',
      marginTop: "1rem",
      //width: "30ch",
    },
  },
  formControl: {
    margin: 8,
    width: "62ch",
  },
  gridList: {
    width: 330,
    height: 400,
    //marginLeft: "-2rem",
  },
  treeVisible: {
    display: "block",
  },
  treeHidden: {
    display: "none",
  },
  textField: {
    fontSize: "14px",
    fontFamily: '"Source Sans Pro",sans-serif',
    "& .MuiInputBase-input": {
      fontSize: "14px",
      fontFamily: '"Source Sans Pro",sans-serif',
    },
  },
  submitButton: {
    color: "#FFFFFF",
    backgroundColor: "#91C73C",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
    "&:hover": {
      backgroundColor: "#91C73C",
      boxShadow: "0px 11px 15px -7px rgb(0 0 0 / 20%)",
    },
  },
  submitButtonDisabled: {
    color: "#FFFFFF",
    backgroundColor: "#9798A0",
    fontWeight: "bold",
    display: "block",
    marginTop: "6px",
    marginRight: "auto",
    marginLeft: "25ch",
    width: "60ch",
  },
  padding: {
    padding: '0px',
  },
  demo2: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  demo3: {
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
}));

const TreeLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  opacity: 1;
  font-family: "Source Sans Pro", sans-serif;
`;


function MeteringPlanItemDialog(props) {

  const { closeModal, refetch, currentItem, meteringPlan, points, groups, tree } = props;
  const advancedSearchContext = useContext(AdvancedSearchContext);

  const { chartIdGroup } = advancedSearchContext;

  const [selected, setSelected] = useState("");
  const [treeView, setTreeView] = useState([]);
  const [name, setName] = useState(currentItem?.parameters.name || "");
  const [valuetype, setValuetype] = useState(currentItem?.parameters.valuetype || "");
  const [value, setValue] = useState(currentItem?.parameters.value || "");
  const [controltype, setControltype] = useState(currentItem?.parameters.controltype || "");
  const [controlvalue, setControlvalue] = useState(currentItem?.parameters.controlvalue || "");
  const [unit, setUnit] = useState(currentItem?.parameters.unit || "");
  const [coef, setCoef] = useState(currentItem?.parameters.coef || "");
  const [usage, setUsage] = useState(currentItem?.parameters.usage || []);
  const [location, setLocation] = useState(currentItem?.parameters.location || "");
  const [locationtype, setLocationtype] = useState(currentItem?.parameters.locationtype || "");
  const [tags, setTags] = useState(currentItem?.parameters.tags || []);
  const [icon, setIcon] = useState(currentItem?.parameters.icon || "");

  const [father, setFather] = useState((currentItem && currentItem.father !== undefined) ? "" + currentItem.father : "");
  const [buttonDisabled, setButtonDisabled] = useState(true);

  const [taglist, setTaglist] = useState([]);
  const [usagelist, setUsagelist] = useState([]);
  const classes = useStyles();

  const handleNameChange = (event) => { setName(event.target.value); };
  const handleIconChange = (event) => { setIcon(event.target.value); };
  const handleValuetypeChange = (event) => { setValuetype(event.target.value); };
  const handleValueChange = (event) => { setValue(event.target.value); };
  const handleControltypeChange = (event) => { setControltype(event.target.value); };
  const handleControlvalueChange = (event) => { setControlvalue(event.target.value); };
  const handleUnitChange = (event) => { setUnit(event.target.value); };
  const handleCoefChange = (event) => { setCoef(event.target.value); };
  const handleUsageChange = (newvalue) => { setUsage(newvalue); };
  const handleLocationChange = (event) => { setLocation(event.target.value); };
  const handleLocationtypeChange = (event) => {
    setLocation("");
    setLocationtype(event.target.value);
  };
  const handleTagsChange = (newvalue) => { setTags(newvalue); };



  useEffect(() => {
    let fulltreeview = [];
    let leaf = {};
    leaf.label = "Racine"
    leaf.id = "0";
    leaf.avobid = "0";

    if (tree && tree.length > 0)
      leaf.children = tree;
    fulltreeview.push(leaf);
    setTreeView(fulltreeview);

    let usagelisttmp = [];
    let taglisttmp = [];
    if (meteringPlan?.items && meteringPlan.items.length > 0) {
      meteringPlan.items.forEach((item) => {
        if (item.parameters?.usage && item.parameters.usage.length > 0) {
          item.parameters.usage.forEach((usage) => {
            if (!usagelisttmp.includes(usage))
              usagelisttmp.push(usage);
          });
        }
        if (item.parameters?.tags && item.parameters.tags.length > 0) {
          item.parameters.tags.forEach((tag) => {
            if (!taglisttmp.includes(tag))
              taglisttmp.push(tag);
          });
        }
      });
    }
    setUsagelist(usagelisttmp);
    setTaglist(taglisttmp);
    // console.log(taglisttmp);
    // console.log(usagelisttmp);
  }, []);

  // console.log(usagelist);
  //Point selection management
  const [selectedPoint, setSelectedPoint] = useState("");
  const handlePointChange = (newValue) => {
    setValue(newValue.id); //use of id and not pointid to avoid sync issues, will be take into account at chart generation
    setSelectedPoint(newValue);
  };
  const selectedPointFunc = () => {
    let selected = {};
    if (selectedPoint !== undefined) {
      selected = selectedPoint;
    }
    return selected;
  };

  //Group selection management
  const [selectedGroup, setSelectedGroup] = useState("");
  const handleGroupChange = (newValue) => {
    setLocation(newValue.id);
    setSelectedGroup(newValue);
  };
  const selectedGroupFunc = () => {
    let selected = {};
    if (selectedGroup !== undefined) {
      selected = selectedGroup;
    }
    return selected;
  };

  const handleSubmit = (event) => {
    if (currentItem)
      updateItem(event);
    else
      createItem(event);
  };

  useEffect(() => {
    if (!name)
      setButtonDisabled(true);
    else
      setButtonDisabled(false);
  }, [name]);

  const createItem = async (event) => {
    let newitem = {
      father: father === '0' ? null : father,
      parameters: {
        name,
        valuetype,
        value,
        controltype,
        controlvalue,
        unit,
        coef,
        usage,
        location,
        locationtype,
        tags,
        icon
      }
    }
    axios
      .post(
        postGEBMeteringPlanItem(father, meteringPlan.id),
        newitem
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        // console.log(res);
        if (res.status == 200) {
          NotificationManager.success("Item créé");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  const updateItem = async (event) => {
    let newitemparameters = {
      ...currentItem.parameters,
      name,
      valuetype,
      value,
      controltype,
      controlvalue,
      unit,
      coef,
      usage,
      location,
      locationtype,
      tags,
      icon
    }
    axios
      .put(
        putGEBMeteringPlanItem(currentItem.id, father),
        newitemparameters
        ,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
            'Content-Type': "application/json; charset=utf-8",
          },
        }
      )
      .then((res) => {
        if (res.status == 200) {
          NotificationManager.success("Item modifié");
          refetch();
          closeModal();
        } else NotificationManager.error("Une erreur est survenue");
      })
      .catch((error) => {
        NotificationManager.error("Une erreur est survenue");
      });
  };

  // console.log(selected);

  return (
    <>

      <form className={classes.root}>
        <GridContainer>
          <GridItem xs={12} sm={6} md={7} lg={7}>
            <div>
              <TextInput
                inputTitle={metringPlanItemText.name}
                textInput={name}
                handleTextInputChange={handleNameChange}
                required
              />
            </div>
            <div>
              <CustomSelectWithIcon
                inputTitle={metringPlanItemText.icon}
                selectValue={icon}
                handleSelectValueChange={handleIconChange}
                data={planitemiconData}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={metringPlanItemText.valuetype}
                selectValue={valuetype}
                handleSelectValueChange={handleValuetypeChange}
                data={valuetypeData}
              />
            </div>
            {
              valuetype === 'point' ?
                (currentItem && value) ?
                  <div>
                    <TextInput
                      inputTitle={metringPlanItemText.name}
                      textInput={value ? points.find((b) => b.id == value)?.name || "" : ""}
                      disabled
                    />
                  </div> :
                  <div>
                    <AutocompleteInputMeters
                      specialWidth={"97%"}
                      inputMargin={"1rem 0rem 0rem"}
                      inputTitle={metringPlanItemText.value}
                      selected={selectedPointFunc()}
                      list={points}
                      handleChange={(_, newValue) =>
                        handlePointChange(newValue)
                      }
                    />
                  </div>
                :
                // valuetype === 'agg' ?
                //   <div>
                //     <CustomSelect
                //       inputTitle={metringPlanItemText.value}
                //       selectValue={value}
                //       handleSelectValueChange={handleValueChange}
                //       data={aggchildrenData}
                //     />
                //   </div>
                //   : 
                <></>

            }
            <div>
              <TextInput
                inputTitle={metringPlanItemText.unit}
                textInput={unit}
                handleTextInputChange={handleUnitChange}
              />
            </div>
            {
              valuetype === 'point' ?
                <div>
                  <FloatInput
                    inputTitle={metringPlanItemText.coef}
                    floatInput={coef}
                    handleFloatInputChange={handleCoefChange}
                  />
                </div> :
                <></>
            }

            <div>
              <AutocompleteTagsInput
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={metringPlanItemText.usage}
                selected={usage}
                list={usagelist}
                handleChange={handleUsageChange}
              />
            </div>
            <div>
              <CustomSelect
                inputTitle={metringPlanItemText.locationtype}
                selectValue={locationtype}
                handleSelectValueChange={handleLocationtypeChange}
                data={locationtypeData}
              />
            </div>
            {
              locationtype === 'freelocation' ?
                <div>
                  <TextInput
                    inputTitle={metringPlanItemText.location}
                    textInput={location}
                    handleTextInputChange={handleLocationChange}
                  />
                </div> :
                <div>
                  <AutocompleteInputMeters
                    specialWidth={"97%"}
                    inputMargin={"1rem 0rem 0rem"}
                    inputTitle={metringPlanItemText.location}
                    selected={selectedGroupFunc()}
                    list={groups}
                    handleChange={(_, newValue) =>
                      handleGroupChange(newValue)
                    }
                  />
                </div>
            }
            <div>
              <AutocompleteTagsInput
                specialWidth={"97%"}
                inputMargin={"1rem 0rem 0rem"}
                inputTitle={metringPlanItemText.tags}
                selected={tags}
                list={taglist}
                handleChange={handleTagsChange}
              />
            </div>
          </GridItem>
          <GridItem xs={12} sm={6} md={5} lg={5}>
            <div
              className={classes.treeVisible}
            >
              <TreeLabel>Position</TreeLabel>
              <ImageList rowHeight={140} className={classes.gridList} cols={1}>
                <MeteringPlanTree
                  items={treeView}
                  expanded={["0"]}
                  selectionmode
                  selected={father}
                  setSelected={setFather}
                />
              </ImageList>
            </div>
          </GridItem>
        </GridContainer>
        <Button
          disabled={buttonDisabled}
          className={
            buttonDisabled
              ? classes.submitButtonDisabled
              : classes.submitButton
          }
          onClick={() => {
            handleSubmit();
          }}
        >
          Enregistrer
        </Button>
      </form>
    </>
  );
}

export default MeteringPlanItemDialog;
